module.exports = __webpack_public_path__ + "img/nexultra-Z.956105aa.png";